import { Link } from "react-router-dom";
import travelmationLogo from "@/assets/travelmation-logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[hsl(222,64%,11%)] text-foreground pt-16 pb-8 border-t border-border/50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">

          {/* Gold shimmer line */}
          <div className="h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent mb-14" />

          <div className="grid md:grid-cols-3 gap-12 mb-14">

            {/* Brand */}
            <div>
              <h3 className="font-serif text-xl font-semibold mb-1 tracking-tight text-foreground">
                Peacefully Ever After
              </h3>
              <p className="font-cinzel text-[0.5rem] text-gold tracking-[0.38em] uppercase mb-6">
                Travels
              </p>
              <p className="font-sans text-muted-foreground text-[0.825rem] leading-relaxed">
                Specializing in Disney vacations for families who want clarity, confidence, and a trip worth remembering.
                <br /><br />
                Based in Georgia — Serving families nationwide.
              </p>
              <p className="font-sans text-muted-foreground text-[0.825rem] leading-relaxed mt-4">
                Bryan Peace is a travel agent with Travelmation.
              </p>
              <a
                href="mailto:bryanpeace@travelmation.net"
                className="font-sans text-gold hover:text-gold/80 text-[0.825rem] transition-smooth mt-1 inline-block">

                bryanpeace@travelmation.net
              </a>
            </div>

            {/* Nav */}
            <div>
              <h4 className="font-cinzel text-[0.55rem] mb-6 uppercase tracking-widest text-muted-foreground/70">
                Explore
              </h4>
              <ul className="space-y-3">
                {[
                { label: "Home", path: "/" },
                { label: "Destinations", path: "/work-with-me" },
                { label: "About", path: "/about" },
                { label: "Blog", path: "/blog" }].
                map((link) =>
                <li key={link.label}>
                    <Link
                    to={link.path}
                    className="font-sans text-muted-foreground hover:text-gold transition-smooth text-[0.825rem]">

                      {link.label}
                    </Link>
                  </li>
                )}
              </ul>
            </div>

            {/* Specialties */}
            <div>
              <h4 className="font-cinzel text-[0.55rem] mb-6 uppercase tracking-widest text-muted-foreground/70">
                Specialties
              </h4>
              <ul className="space-y-3 font-sans text-[0.825rem] text-muted-foreground">
                <li>Walt Disney World®</li>
                <li>Disney Cruise Line®</li>
                <li>Universal Orlando</li>
                <li>All-Inclusive Resorts</li>
                <li>Custom Vacations</li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-border/40">
            <p className="text-center font-sans text-[0.775rem] text-muted-foreground/60">
              &copy; {currentYear} Peacefully Ever After Travels. All rights reserved.
            </p>
            <p className="text-center font-sans text-[0.7rem] text-muted-foreground/35 mt-2">
              Walt Disney World®, Disney Cruise Line®, Magic Kingdom®, EPCOT®, Hollywood Studios®, Animal Kingdom®, and Lightning Lane™ are registered trademarks of The Walt Disney Company. Peacefully Ever After Travels is not affiliated with, sponsored by, or endorsed by The Walt Disney Company or its affiliates.
            </p>
          </div>
        </div>
      </div>
    </footer>);

};